import React, { createContext, useContext, useState } from 'react';

const StateContext = createContext();

const initialIsClickedState = {
  searchBox: false,
  menuDropDown: false,


};

export const ContextProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState({
    documents: [],
    products: [],
  });
  const [selectedItemsInCart, setSelectedItemsInCart] = useState([]);
  const [isClicked, setIsClicked] = useState(initialIsClickedState);
  const [totalPrice, setTotalPrice] = useState(0);

  const handleClick = (event, clicked) => {
    event.stopPropagation();
    if (!clicked) {
      setIsClicked(initialIsClickedState);
      return;
    }
    setIsClicked({
      ...initialIsClickedState,
      [clicked]: true
    });
  }

  return (
    <StateContext.Provider
      value={{
        cartItems, setCartItems,
        isClicked, setIsClicked, handleClick,
        selectedItemsInCart, setSelectedItemsInCart,
        totalPrice, setTotalPrice
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);